import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { useParams } from "react-router-dom";

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Heading,
  VStack,
  Divider,
  Image,
  InputGroup,
  InputRightElement,
  Flex,
  Text,
} from "@chakra-ui/react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../api";

const schema = yup.object({
  newPassword: yup.string().required("New Password is required"),
  confirmPassword: yup.string().required("Confirm Password is required"),
});

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const { token } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleCPasswordVisibility = () => {
    setShowCPassword((prev) => !prev);
  };

  const onSubmit = async (data) => {
    const token1 = token.split("token=");

    try {
      const response = await axios.post(
        `${BASE_URL}/auth/reset-password`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token1[1]}`,
          },
        }
      );
      console.log(response.data);
      if (response.status === 201) {
        navigate("/");
        localStorage.setItem("access_token", response.data.access_token);
      } else {
        console.error("Error logging in");
      }
    } catch (error) {
      console.error("Error logging in:", error);
    }
    // navigate('/');
  };
  useEffect(() => {
    // const token1 = searchParams.get('token');
    // setToken(token1)
  });

  return (
    <>
      <Flex w="100%">
        <Box w="53%" bg="blue.600" h={"100vh"}>
          <Box h="33%" w="100%">
            <Image justifySelf={"start"} w={"60%"} src={"/assets/1.png"} />
          </Box>
          <Box w="100%" alignContent="center" h="34%" justifySelf="center">
            <Text
              textAlign="center"
              textColor="white"
              fontSize="4xl"
              fontWeight="semibold"
            >
              Password Reset
            </Text>
            <Text textAlign="center" textColor="white" fontSize="lg">
              Set Your new password to sign in with ease
            </Text>
          </Box>
          <Box alignContent="end" h="33%" w="100%" justifySelf="center">
            <Image justifySelf={"center"} w={"80%"} src={"/assets/2.png"} />
          </Box>
        </Box>
        <Box w={"47%"} h={"100vh"} alignContent={"center"}>
          <Box
            py={3}
            px={{ base: 4, md: 8 }}
            rounded={"xl"}
            align={"center"}
            h={"fit-content"}
            w={{
              base: "90%",
              md: "80%",
              lg: "70%",
              xl: "50%",
              xxl: "40%",
            }}
            justifySelf={"center"}
            color={"#008DD1"}
            // bg={'#F7F9FF'}
          >
            <Image
              justifySelf={"center"}
              w={"100px"}
              src={"/assets/digital-bikana.png"}
            />
            <Heading fontSize={"2xl"} textAlign={"center"}>
              Reset Password!
            </Heading>
            <Divider
              mt={"10px"}
              justifySelf={"center"}
              borderColor={"#008DD1"}
              borderWidth={"0.15rem"}
              opacity={100}
              rounded={"full"}
              width="15%"
            />
            <form onSubmit={handleSubmit(onSubmit)}>
              <VStack spacing={4}>
                <FormControl isInvalid={!!errors.password}>
                  <FormLabel>Password</FormLabel>
                  <InputGroup>
                    <Input
                      {...register("newPassword")}
                      rounded={"full"}
                      placeholder="Enter New Password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      _hover={{ borderColor: "gray.400" }}
                      border={"1px"}
                      borderColor={"gray.300"}
                      _placeholder={{ color: "gray.500" }}
                    />
                    <InputRightElement>
                      <Button variant="link" onClick={togglePasswordVisibility}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                  <FormErrorMessage>
                    {errors.newPassword?.message}
                  </FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.password}>
                  <FormLabel>Confirm Password</FormLabel>
                  <InputGroup>
                    <Input
                      {...register("confirmPassword")}
                      rounded={"full"}
                      placeholder="Confirm New Password"
                      type={showCPassword ? "text" : "password"}
                      autoComplete="current-password"
                      _hover={{ borderColor: "gray.400" }}
                      border={"1px"}
                      borderColor={"gray.300"}
                      _placeholder={{ color: "gray.500" }}
                    />
                    <InputRightElement>
                      <Button
                        variant="link"
                        onClick={toggleCPasswordVisibility}
                      >
                        {showCPassword ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                  <FormErrorMessage>
                    {errors.confirmPassword?.message}
                  </FormErrorMessage>
                </FormControl>

                <Button
                  // mt={{ base: 4, md: 4, lg: 6, xl: 8 }}
                  rounded={"full"}
                  type="submit"
                  bg={"#008DD1"}
                  w="100%"
                  _hover={{ opacity: "0.8" }}
                  color={"white"}
                >
                  Reset Password
                </Button>
              </VStack>
            </form>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default UpdatePassword;
